<ng-container *ngIf="leadForm?.form; else noFormFound">
    <flexiform-interpreter *ngIf="leadForm && !sendOk && !thanksHtmlText && !userAlreadyExists" 
    [schema]="leadForm" 
    [logo]="logoUrl"
    (onSaveForm)="sendForm($event)"></flexiform-interpreter>
    <div *ngIf="(sendOk && thanksHtmlText) || error" class="feedback-section">
        <div class="container">
            <div class="row">
                <div *ngIf="sendOk && thanksHtmlText" class="col-12 col-lg-4 offset-lg-4 d-flex-col-center">
                    <div class="logo" *ngIf="logoUrl">
                        <img [src]="logoUrl" alt="logo">
                    </div>
                    <div [innerHtml]="thanksHtmlText | safeHtml"></div>
                </div>
                <div *ngIf="error" class="col-12 col-lg-4 offset-lg-4">
                    <div class="text-center logo" *ngIf="logoUrl">
                        <img [src]="logoUrl" alt="logo">
                    </div>
                    <div class="text-center"><p>{{error.error.message}}</p></div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="userAlreadyExists">
    <section class="full-window">
        <div class="container">
            <div class="row">
                <div class="col-12 content-center" *ngIf="userAlreadyExistsObj">
                    <p class="text-center" *ngIf="userAlreadyExistsObj?.form_completed">
                        Este usuario ya está registrado en Atalaya y con un proyecto asignado.<br> 
                        Puedes acceder a Atalaya para actualizar la información del proyecto desde <a [href]="userAlreadyExistsObj.link" target="_blank">aquí</a>.
                    </p>
                    <p class="text-center" *ngIf="!userAlreadyExistsObj?.form_completed">
                        Este usuario ya está registrado en Atalaya.<br> 
                        Parece que tienes un formulario pendiente de rellenar. Haz click <a [href]="userAlreadyExistsObj.link" target="_blank">aquí</a> para comenzar.
                    </p>
                </div>
            </div>
        </div>    
    </section>
</ng-container>

<ng-template #noFormFound>
    <section class="full-window" *ngIf="!loading">
        <div class="container">
            <div class="row">
                <div class="col-12 content-center">
                    <p>El formulario con id <span><i>{{slug}}</i></span> no está disponible. Ponte en contacto con el administrador.</p>
                </div>
            </div>
        </div>    
    </section>
</ng-template>

<ng-container *ngIf="loading">
    <div class="h-100 w-100 d-flex justify-content-center align-items-center">
        <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </div>
</ng-container>


<onwac-snackbar 
*ngIf="feedback"
[status_class]="snackbar.status_class"
[text]="snackbar.text"
[autoClose]="snackbar.autoClose"
[activate]="snackbar.active"
(hidden)="snackbar.deactivate()"
></onwac-snackbar>
